import { initPublicHomeAnalytics } from './analytics';
import { initPublicHomeMarketing } from './marketing';
import { initPublicHomeUpload } from './upload';
import { resolveVariantKey } from './variants';

const csrfToken = document.querySelector('#data-csrf-token')?.textContent?.trim() || '';

initPublicHomeAnalytics(resolveVariantKey());
initPublicHomeMarketing();
initPublicHomeUpload({ csrfToken });
